<template>
  <ComplaintsTable
    @select="$router.push({ name: 'complaint.item', params: { id: $event.id } })"
    @filer-changed="filterParams = $event"
    v-if="mode == VMODE_TABLE"
  />
</template>

<script setup>
import { useSessionStorage } from '@vueuse/core'
import ComplaintsTable from './list/table.vue'

const VMODE_TABLE = 2

const mode = useSessionStorage('complaints:mode', VMODE_TABLE)

</script>
